// extracted by mini-css-extract-plugin
export var verifyForm = "styles-module--verifyForm--2HSuP";
export var verifyTitle = "styles-module--verifyTitle--1RD3P";
export var verifyText = "styles-module--verifyText--y-xsf";